export enum ShippingMethodPropertyMetadataCode {
  Description = 'DESCRIPTION',
  Longitude = 'LONGITUDE',
  Latitude = 'LATITUDE',
}
